import axios from "axios";

import { env } from "~/env";
import { useUserStore } from "~/stores/useUserStore";
import { errorResponseInterceptor } from "./interceptors";

export const api = axios.create({
  baseURL: env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getAuthHeaders = () => {
  const userToken = useUserStore.getState().accessToken;

  return {
    Authorization: `Bearer ${userToken}`,
  };
};

api.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().accessToken;
    if (token) {
      if (config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// interceptor was based on this article
// https://dev.to/franciscomendes10866/how-to-use-axios-interceptors-b7d
api.interceptors.response.use((response) => response, errorResponseInterceptor);

// Separate instance for refresh (NO interceptors)
export const refreshApi = axios.create({
  baseURL: env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

refreshApi.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().accessToken;
    if (token) {
      if (config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export interface ServicePagination {
  count: number;
  total: number;
  perPage: number;
  currentPage: number;
  totalPages: number;
  links: {
    previous?: string;
    next?: string;
  };
}

export interface ServiceResponse<T> {
  status: number;
  success: boolean;
  data: T;
  pagination?: ServicePagination;
}
